/**
 * Avoid hanging iframe renew when tokens are expired — clear them and treat as logged out.
 * Used by session/login paths so paint is never blocked on Okta renew.
 */
export const OKTA_NO_RENEW = { onExpiredToken: 'remove' as const };

/**
 * Isolate internal vs external Okta tokenManager storage.
 * A shared default `okta-token-storage` key caused cross-flow renew hangs (ES-14917).
 */
export const OKTA_TOKEN_STORAGE_KEYS = {
  internal: 'okta-token-storage-internal',
  external: 'okta-token-storage-external',
} as const;
